import React, { useEffect, useState } from "react";
import AdminPhotoCategoryForm from "../../components/adiminComponents/AdminPhotoCategoryForm";
import AdminPhotoUpload from "../../components/adiminComponents/AdminPhotoUpload";
import { getAllCategories, deleteCategory } from "../../services/photoCategoryService";
import { FILE_BASE_URL } from "../../utils/constants";

export default function AdminGalleryPage() {
  const [categories, setCategories] = useState([]);
  const buildFileUrl = (url) =>
    url?.startsWith("http")
      ? url
      : `${FILE_BASE_URL.replace(/\/$/, "")}/${String(url || "").replace(/^\//, "")}`;

  const loadCategories = () => {
    getAllCategories().then(setCategories);
  };

  useEffect(() => {
    loadCategories();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Delete this category?")) {
      await deleteCategory(id);
      loadCategories();
    }
  };

  return (
    <div className="container mt-4">
      <h3>🖼️ Admin Photo Gallery Management</h3>
      <div className="row">
        <div className="col-md-4">
          <AdminPhotoCategoryForm onSuccess={loadCategories} />
          <AdminPhotoUpload />
        </div>
        <div className="col-md-8">
          <h5 className="mt-3">Existing Categories</h5>
          <div className="row">
            {categories.map((c) => (
              <div className="col-md-4 mb-3" key={c.id}>
                <div className="card shadow-sm">
                  <img
                    src={buildFileUrl(c.photoUrl)}
                    className="card-img-top"
                    alt={c.name}
                    style={{ height: 150, objectFit: "cover" }}
                  />
                  <div className="card-body text-center">
                    <h6>{c.name}</h6>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(c.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
